export default "__VITE_ASSET__CeBM3a7k__"